import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  snapBailiffDetail,
  unSnapBailiffDetail,
} from "store/bailiff/bailiff/document/bailiff_document.action";
import {
  bailiffDocumentOpenPaySelector,
  bailiffDocumentSelectedSelector,
} from "store/bailiff/bailiff/document/bailiff_document.selector";
//
//component
//redux
//selector
//actions
export const TriggerInit = () => {
  // -------------------------- VAR ----------------------------
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  const selected = useSelector(bailiffDocumentSelectedSelector);
  const open = useSelector(bailiffDocumentOpenPaySelector);
  const id = selected?.id;
  // -------------------------- USE EFFECT ---------------------
  useEffect(() => {
    if (id && open) {
      dispatch(snapBailiffDetail({ id }));
    }

    return () => dispatch(unSnapBailiffDetail());
  }, [id, open, dispatch]);
  // -------------------------- RETURN --------------------------
  return <></>;
};
export default TriggerInit;
